import React from 'react';

import { NavLink } from "react-router-dom";

import { Link } from "react-scroll";

import './navscreen.css';

const Navscreen = () => {
    return (
        <nav className="navscreen">
            <ul className="navscreen__links">
                <li>
                    <NavLink exact to="/">ACCUEIL</NavLink>
                </li>
                <li>
                    <NavLink to="/baby-shower">BABY SHOWER</NavLink>
                </li>
                <li>
                    <NavLink to="/anniversaire">ANNIVERSAIRE</NavLink>
                </li>
                <li>
                    <NavLink to="/mariage">MARIAGE</NavLink>
                </li>
                <li>
                    <NavLink to="/mignardises">MIGNARDISES</NavLink>
                </li>
                <li>
                    <NavLink to="/tarifs">TARIFS</NavLink>
                </li>
                <li>
                    <NavLink to="/formations">FORMATIONS</NavLink>
                </li>
                {/* <li>
                    <NavLink to="/faq">FAQ</NavLink>
                </li> */}
                <li>
                <Link
                    activeClass="active"
                    to="contact"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                >CONTACT</Link>
                </li>
            </ul>
      </nav>
    );
};

export default Navscreen;